import axios from '../request/http';
import { toFormData } from '../common/descriptions'

const cabinet = {
    // 自助柜列表
    getLockerList(params) {
        return axios.get("/admin/locker/list", { params });
    },
    // 自助柜管理员列表
    getLockerAdminList(params) {
        return axios.get("/admin/locker/admin/list", { params });
    },
    // 删除管理员
    getLockerAdminDel(params) {
        return axios.get("/admin/locker/admin/del", { params });
    },
     // 新增管理员
     getLockerAdminAdd(params) {
        return axios.get("/admin/locker/admin/add", { params });
    },
    // 启用/禁用管理员
    getLockerAdminUpdate(params) {
        return axios.get("/admin/locker/admin/update", { params });
    },
    // 自助柜柜门列表
 getLockerDoorList(params) {
    return axios.get("/admin/locker/door/list", { params });
},
 // 启用/禁用柜门
 getLockerCompanyUpdate(params) {
    return axios.get("/admin/locker/company/update", { params });
},
    // 编辑删除banner
    examBannerEdit(data) {
        return axios.post("/admin/exam-set/banner/edit", data);
    },

}

export default cabinet;


// WEBPACK FOOTER //
// ./src/api/cabinet.js